import template from './commercial-ownership-verification.jade';
import { CommercialOwnershipWidget } from './commercial-ownership-verification.controller';

// Эта директива по-факту является просто оберткой над реакт-компонентом
// создана для того, чтобы можно динамически добавлять и удалять блок с виджетом
export default () => {
  return {
    template,
    scope: {},
    replace: true,
    bindToController: {},
    controller: CommercialOwnershipWidget,
    controllerAs: 'commercialOwnershipWidgetCtrl',
  };
};
